
import React from 'react';
// template components
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// images
import highResDesktopImageWebp from './images/variable-universal-life-insurance-hero.webp';
import highResMobileImageWebp from './images/variable-universal-life-insurance-hero-mobile.webp';
// low res images
import { lowResImageDesktop, lowResImageMobile } from './lowResImages';
// styles
import { HeroSectionStyled } from './styles';

export default () => {
  return (
    <HeroSectionStyled
      sectionId='variable-universal-life-insurance-hero'
      moduleName='hero-module'
      moduleVariation='A'
      productName='Variable Universal Life Insurance (VUL)'
      headingText={<>Get more flexibility and control <WidowBlock>with VUL.</WidowBlock></>}
      descriptionText='Variable Universal Life (VUL) lets you protect the people you love with customized coverage and gives you control over how your cash value is invested.'
      ctaPrimary={{
        linkUrl: '/find-a-financial-advisor/',
        buttonText: 'Get insurance',
        ariaLabel: 'Connect with a financial advisor',
        children: '',
      }}
      backgroundImageAriaLabel='a smiling man carries his laughing girlfriend on his back on a rocky beachfront'
      backgroundImageDesktop={highResDesktopImageWebp.toString()}
      backgroundImageMobile={highResMobileImageWebp.toString()}
      backgroundImageDesktopLowRes={lowResImageDesktop}
      backgroundImageMobileLowRes={lowResImageMobile}
      backgroundVariant='lightB'
      themeType='lightTheme'
    />
  );};
